import type { FC } from "react";
import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { ToolRowCommonProps } from "web_myplann/Portfolio/Helpers/investmentToolTypes";
import { useToolSummary } from "web_myplann/Portfolio/Helpers/useToolSummary";
import {
	getPortfolioFrequencyValue,
	toolHasActivePeriodicPurchaseInstructions,
} from "web_myplann/Portfolio/Helpers/utils";
import { DataRow } from "web_myplann/Shared/Components/DataRow";
import { ToolRowWrapper } from "./ToolRowWrapper";

const PageResources = Resources.PortfolioDetail;

export const CommodityToolRow: FC<ToolRowCommonProps> = ({
	tool,
	toolIdx,
	portfolioId,
	currencySign,
	toolsSummary,
	expanded,
	onToggle,
	noDivider,
}) => {
	const { t } = useResource();
	const { totalValue, totalInvested } = useToolSummary(tool.id, toolsSummary);

	const hasActivePurchases = toolHasActivePeriodicPurchaseInstructions(tool);
	const shouldShowRegularPayment =
		hasActivePurchases && tool.monthlyPayment > 0;

	return (
		<ToolRowWrapper
			label={`${tool.name} (${tool.identification})`}
			totalValue={totalValue}
			expanded={expanded}
			onToggle={onToggle}
			noDivider={noDivider}
			portfolioId={portfolioId}
			toolIdx={toolIdx}
		>
			{shouldShowRegularPayment && (
				<DataRow
					label={t(PageResources.ToolHistory.Commodity.regularPayment)}
					value={getPortfolioFrequencyValue(
						tool.monthlyPayment,
						currencySign,
						ClientPortfolioPaymentFrequencyEnum.Monthly,
						t,
						0,
					)}
				/>
			)}
			<DataRow
				label={t(PageResources.ToolHistory.Commodity.invested)}
				value={totalInvested}
			/>
			<DataRow
				label={t(PageResources.ToolHistory.Commodity.value)}
				value={totalValue}
			/>
		</ToolRowWrapper>
	);
};
